import { Link } from "react-router-dom";
import { Construction } from "lucide-react";
import PageHeader from "./PageHeader.jsx";
import { useI18n } from "../lib/i18n.jsx";

export default function ComingSoon({ icon: Icon, title, subtitle, detail }) {
  const { t } = useI18n();
  return (
    <div className="flex flex-col min-h-[60vh]">
      <PageHeader icon={Icon} title={title} subtitle={subtitle} />
      <div className="flex-1 flex items-center justify-center px-6 md:px-10 py-12">
        <div className="card max-w-lg w-full text-center space-y-4 border-white/10">
          <div className="mx-auto h-14 w-14 rounded-2xl bg-amber-500/10 border border-amber-500/25 flex items-center justify-center">
            <Construction className="h-7 w-7 text-amber-300" />
          </div>
          <h2 className="text-xl font-semibold">
            {t("home.comingSoon", "(coming soon)").replace(/[()]/g, "")}
          </h2>
          <p className="text-white/60 text-sm leading-relaxed">{detail}</p>
          <p className="text-white/40 text-xs">
            {t(
              "comingSoon.availableNow",
              "Chat, code, speech, and Video Studio are available now."
            )}
          </p>
          <Link to="/" className="btn-primary inline-flex !py-2 !px-4 text-sm">
            {t("comingSoon.backHome", "Back to home")}
          </Link>
        </div>
      </div>
    </div>
  );
}
